import apiClient from './axios-config';

export const landingPageApi = {
  getAll: () => apiClient.get('/landing-page'),

  getByKey: (key) => apiClient.get(`/landing-page/${key}`),

  getAllAdmin: (search) => {
    const params = search ? { search } : {};
    return apiClient.get('/landing-page/admin/all', { params });
  },

  getAdminByKey: (key) => apiClient.get(`/landing-page/admin/${key}`),

  create: (data) => apiClient.post('/landing-page/admin', data),

  update: (key, data) => apiClient.patch(`/landing-page/admin/${key}`, data),

  delete: (key) => apiClient.delete(`/landing-page/admin/${key}`),

  toggleActive: (key) => apiClient.patch(`/landing-page/admin/${key}/toggle`),

  getMobileApps: () => apiClient.get('/landing-page/mobile-apps').then(res => res.content || {}).catch(() => null),

  getSocialMedia: () => apiClient.get('/landing-page/social-media').then(res => res.content || {}).catch(() => null),

  getContactInfo: () => apiClient.get('/landing-page/contact-info').then(res => res.content || {}).catch(() => null),

  sendContactInquiry: (data) => apiClient.post('/contact-inquiries', data),
};
